import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";
import commonSwrConfig from "../commonSwrConfig";
import useSWR, { SWRResponse } from "swr";
import { IMorningstarSecuritiesEsg } from "@portal/types/api/IMorningstarSecuritiesEsg";
import { IUseMorningstarSecuritiesEsg } from "./types";

const useMorningstarSecuritiesEsg: IUseMorningstarSecuritiesEsg = (isin?: string) => {
  const { update } = useSession();

  const { data, error, isLoading }: SWRResponse<IMorningstarSecuritiesEsg, unknown> = useSWR(
    `/api/morningstar/securities/esg/${isin}`,
    commonFetcher<IMorningstarSecuritiesEsg>,
    commonSwrConfig(update),
  );
  return { data, error, isLoading };
};

export default useMorningstarSecuritiesEsg;
